import { observer } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import { useBlockedByMeUserPanelPresenter } from './BlockedByMeUserPanel.presenter';
import styles from './BlockedByMeUserPanel.styles.m.css';

export const BlockedByMeUserPanel = observer(() => {
  const { t } = useTranslation();
  const presenter = useBlockedByMeUserPanelPresenter();

  return (
    <div className={styles.container}>
      <Button
        isDisabled={presenter.isDisabled}
        isLoading={presenter.isLoading}
        onClick={presenter.unblock}
        theme="text-thirty"
      >
        {t('unblock_user')}
      </Button>
    </div>
  );
});
